/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Smallurl1Inputs */

const en_entity_smallurl1 = /** @type {(inputs: Entity_Smallurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small URL`)
};

const de_entity_smallurl1 = /** @type {(inputs: Entity_Smallurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine URL`)
};

/**
* | output |
* | --- |
* | "Small URL" |
*
* @param {Entity_Smallurl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_smallurl1 = /** @type {((inputs?: Entity_Smallurl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Smallurl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_smallurl1(inputs)
	return de_entity_smallurl1(inputs)
});
export { entity_smallurl1 as "entity_smallUrl" }